import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  CONTACT_US_TRIGER,
  I_POP_OVER,
  MESSAGE_TYPE,
  USER_GUIDE_MODAL,
} from "../../constants";
import { setGuideOpenAction } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import ContactUs, { companyLink } from "../../components/ContactUs/ContactUs";
import SpeakToAdmin from "../../components/SpeakToAdmin/SpeakToAdmin";
import { sendMessageToAdmin } from "../../actions/chat";
import { useNavigate } from "react-router";
import { sendMessageToAdminChat } from "../../actions/chatv2";
export default function InfoModalStatic({
  infoModalStaticShow,
  infoModalStaticClose,
  infoModalStaicShowType,
  infoModalStaticCustomMessage,
}) {
  const dispatch = useDispatch();

  const openUseGuide = (guideName) => {
    dispatch(setGuideOpenAction(true, guideName));
    infoModalStaticClose();
  };

  const handleClose = () => { };

  const navigate = useNavigate();
  const { selectedCompany } = useSelector((state) => state.company);
  const [contactLoader, setContactLoader] = useState(true);

  useEffect(() => {
    setContactLoader(false);
  }, []);

  const sendMessageToAdminfunc = async () => {
    setContactLoader(true);
    let message = `I am interested to invite individual referral for ${companyLink(
      selectedCompany
    )}`;
    await sendMessageToAdminChat(
      `<strong>Speak to admin:</strong> ${message}`,
      selectedCompany,
      MESSAGE_TYPE.CONTACT_US_BUTTON,
      navigate,
      []
    );
    setContactLoader(true);
    setTimeout(() => {
      infoModalStaticClose();
    }, 100);
  };

  return (
    <>
      <Modal
        show={infoModalStaticShow}
        onHide={infoModalStaticClose}
        className="custom-modal info-modal ps-0"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {infoModalStaicShowType === I_POP_OVER.BUSINESS_NAME ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Business name</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Every business needs a name to differentiate itself from other
                businesses.
              </p>
              <span className="edit-description">
                Tips of choosing a business name
              </span>
              <ul className="edit-description m-0">
                <li>No obscene names</li>
                <li>
                  Use caution of words that may require additional licenses, for
                  e.g crypto
                </li>
                <li>
                  Choose something that is as close as possible to your website
                  domain
                </li>
              </ul>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.REGISTERED_ADDRESS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Registered address</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Every holding company created has a default registered address.
                You can use this default address and put it on contracts or
                agreements immediately.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.WEBSITE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Company website</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Although not compulsory, including a website url would
                legitimise the holding company greatly.
              </p>
              <span className="edit-description">
                Tips of choosing a website url
              </span>
              <ul className="edit-description m-0">
                <li>use a .com extension</li>
                <li>keep it short and simple</li>
                <li>avoid numbers or hyphens</li>
                <li>be unique and memorable</li>
                <li>use keywords</li>
                <li>do your research</li>
                <li>use a domain name generator</li>
              </ul>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.PRIMARY_ACTIVITY ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Primary activity</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Each holding company must have at least one business activity.
                The primary activity is your key business activity. This
                activity is what your company is created to do primarily
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.SECONDARY_ACTIVITY ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Secondary activity</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The secondary activity is not compulsory. If added, this
                activity refers to the supporting activity that supports the
                primary activity.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.ACTIVATE_BUSINESS_SHAREHOLDER ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">What is a shareholder?</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A shareholder owns part of the company by holding shares in it.
                They can be investors, co-founders, family members, or anyone
                contributing capital in exchange for ownership. Shareholders
                don't need to be involved in day-to-day running of the business
                — that's the role of directors.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.ACTIVATE_BUSINESS_DIRECTOR ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">What is a director?</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A director is legally responsible for running the company and
                making key decisions on its behalf. Every Singapore company
                needs at least one director who is a resident of Singapore —
                that's the role kimbocorp's resident director fulfils if you
                don't have your own candidate. If you bring your own director,
                they take on real legal responsibilities for the company, the
                same as anywhere else.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.SHAREHOLDERS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Shareholders</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A shareholder is a person who owns a portion of the holding
                company when he/she contributes, financially or non-financially,
                towards the holding company. By paying for the shares, or being
                issued with shares, the shareholder is a partial owner of the
                holding company.
              </p>
              <p className="edit-description">
                Here you can see individual persons being added as potential
                shareholders to a holding company. People here who accept the
                invitation will show up in the message (chat) section. You can
                then communicate directly with to explain and convince them to
                invest in the holding company's business.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.DIRECTORS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Directors</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A director is a person who is responsible for managing the
                affairs of the holding company and setting the business's
                strategic direction. A director has the legal duty to advance
                the interest of the holding company, act honestly and practise
                good faith in exercising the given powers. A director is also
                required to ensure there are resources within the holding
                company for the preparation of financial statements, corporate
                filings and other disclosures and record keeping (i.e. minutes
                of meetings).
              </p>
              <p className="edit-description">
                Here you can see individual persons being added as potential
                directors to a holding company. People here who accept the
                invitation will show up in the message (chat) section. You can
                then communicate directly with them to explain and convince them
                to contribute to the holding company's business
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.PROMOTERS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Promoter</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A promoter is a person who does the preliminary work related to
                starting a holding company, including its creation, scope,
                formalisation, solicitation, progression and promotion. This
                person usually advises the shareholders and beneficial owners of
                the holding company on its activities and makes sure all are
                clear on the intent and objectives of the holding company.
              </p>
              <p className="edit-description">
                Any person, including agents, consultants, accountants, legal
                professionals, engineers or bankers, can be a promoter.
              </p>
              <p className="edit-description">
                They are usually ideal persons to become directors and c-level
                executives of that company.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.LICENSES ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Licenses</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Coming soon
                {/* Some businesses need licenses and permits to operate in their chosen activity. We look forward to simplify the process of helping you acquire the licenses your business needs. */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.VERIFY_BUSINESS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Verify business</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Choose myinfo Business if the business is already registered in
                Singapore. Choose Manual Verification if the business is
                registered outside Singapore or has not been registered.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.BUSINESS_DETAIL ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Why Verify Your Business?</h5>
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description mb-0 mt-2">
                Verifying your business lets us tailor your experience to meet
                your unique needs.
              </p>
              <ul className="edit-description m-0">
                <li>
                  For Singapore businesses: Use MyInfo for instant verification
                </li>
                <li>
                  For other locations: Speak with us for quick manual
                  verification
                </li>
              </ul>
              <p className="edit-description mb-0 mt-2">Benefits:</p>
              <ul className="edit-description m-0">
                <li>Personalized recommendations and tools</li>
                <li>Access to features optimized for your business</li>
                <li>Tailored support from our advisors</li>
              </ul>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.BOOK_OF_BUSINESS_ACTION_INDIVIDUAL ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                “Make public" will allow kimbocorp to show your email address
                and full name to other users who are interested in having you
                introduce this profile (or any profile you add) to them.
              </p>
              <p className="edit-description">
                Note that no attempt will be made by anyone to connect or engage
                with this profile as the profile details will be hidden for all
                users.
              </p>
              <p className="edit-description">
                You may then receive email notifications and other app
                notifications should you be invited by other users to make
                introduction to this profile (or any profile you add).
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.BOOK_OF_BUSINESS_ACTION_COMPANY ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                “Connect" will allow kimbocorp to introduce this profile to you.
              </p>
              <p className="edit-description">
                Note that while we cannot ensure the profile will reciprocate,
                you are at least assured that there is a real attempt to connect
                with this profile for the purpose of introducing this profile to
                you.
              </p>
              <p className="edit-description">
                You may then receive email notifications and other app
                notifications should this profile accept the connection request.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.BOOK_OF_BUSINESS_SUGGESTED_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                You can suggest this profile for any of the below functions
              </p>
              <ol>
                <li>
                  Potential customer - someone whom you believe can be customer
                  for a particular business
                </li>
                <li>
                  Potential investor - someone whom you believe can be an
                  investor for a particular business
                </li>
                <li>
                  Potential director - someone whom you believe can be a
                  director for a particular business
                </li>
                <li>
                  Potential employee - someone whom you believe can be an
                  employee for a particular business
                </li>
                <li>
                  Potential vendor or supplier - someone whom you believe can
                  supply products or services to a particular business
                </li>
              </ol>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.BOOK_OF_BUSINESS_SUGGESTED_POTENTIAL_PURPOSE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Potential purpose refers to the potential role that you are
                considering this profile for. You can contact us to tell us what
                role you are hoping to appoint. Some of the roles include:
              </p>
              <ol>
                <li>
                  Potential customer - someone whom you believe can be customer
                  for your business
                </li>
                <li>
                  Potential investor - someone whom you believe can be an
                  investor for your business
                </li>
                <li>
                  Potential director - someone whom you believe can be a
                  director for your business
                </li>
                <li>
                  Potential employee - someone whom you believe can be an
                  employee for your business
                </li>
                <li>
                  Potential vendor or supplier - someone whom you believe can
                  supply products or services to your business
                </li>
              </ol>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.SHAREHOLDERS_DIRECTOR_STATUS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This shows the status of the user pertaining to this particular
                business account
              </p>
              <p className="edit-description">
                Pending - user has been invited pending acceptance
              </p>
              <p className="edit-description">
                Invite accepted - user has accepted invite and available to chat
              </p>
              <p className="edit-description">
                Removal in progress - user is being uninvited from this business
                account and not from the platform in general
              </p>
              <p className="edit-description">
                Official - user is an official stakeholder of the business
              </p>

              {/* <p className="edit-description">Acceptance in progress - This appointment is pending admin approval.</p>
              <p className="edit-description">Amendment in progress - This amendment is pending admin approval.</p>
              <p className="edit-description">Removal in progress - This removal is pending admin approval.</p>
              <p className="edit-description">Enquire about all its status via the admin chat.</p> */}
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.REFERAL_FRIEND ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Inviting others to kimbocorp goes beyond just bringing in new
                users—it’s about building connections within your own business
                ventures too! Here’s how it works:
              </p>
              <ul className="edit-description m-0 numbered-list">
                <li>
                  Invite users to join kimbocorp: Share the benefits of
                  kimbocorp with friends, colleagues, or contacts. When they
                  join and incorporate a business, you’ll receive a payout.
                </li>
                <li>
                  Create a business on kimbocorp and invite key roles: Set up
                  unlimited businesses on kimbocorp and invite people to
                  essential roles such as promoters, directors, or shareholders.
                  This allows them to participate and engage in your business
                  setup process.
                </li>
                <li>
                  Earn payouts for successful Incorporations: Whenever an
                  invited user, promoter, director, or shareholder from any
                  kimbocorp business successfully incorporates the business,
                  you’ll receive a payout, recognizing your role in building an
                  active network of committed business partners.
                </li>
              </ul>
              <p>
                Start inviting today and build a thriving network within
                kimbocorp—one that rewards you for every successful business
                incorporation!{" "}
                {contactLoader && (
                  <i className="animateSpin fa-solid fa-circle-notch"></i>
                )}{" "}
                <b onClick={sendMessageToAdminfunc} className="cursor-pointer">
                  Speak to kimbocorp admin to find out more .
                </b>
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.DEFAULT_SUGGESTED_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                You can suggest your friends and professional networks to other
                companies created on kimbocorp.com.{" "}
                {/* <b
                  onClick={() => openUseGuide(USER_GUIDE_MODAL.SUGGESTED)}
                  className="cursor-pointer"
                >
                  Learn more.
                </b> */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.COMPANY_SUGGESTED_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This list stores potential stakeholders who may help your
                holding company or fund, such as potential investors. You may
                add existing ones you know to send them an invite or contact us
                to find new ones
                {/* You can see profiles that kimbocorp and other users have suggested for your business. <b onClick={() => openUseGuide(USER_GUIDE_MODAL.COMPANY_SUGGESTED)} className="cursor-pointer">Learn more.</b> */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.COMPANY_WARM_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This list stores potential stakeholders who may be interested to
                help your holding company or fund, such as potential investors.
                You may add existing ones you know to send them an invite or
                contact us to find new ones.
                {/* Profiles who have shown an interest in the affairs of this company will be shown here. */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.COMPANY_MEETING_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This list stores potential stakeholders who are willing to speak
                and learn more about your holding company or fund, such as
                potential investors. You may add existing ones you know to send
                them an invite or contact us to find new ones.
                {/* Profiles who have shown an interest to speak with directors of the company will be shown here. */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.COMPANY_SUGGESTED_ADD_PROFILE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                You can also add a profile who you like to meet or engage with.
                kimbocorp will try to help you with the “first-hand shake”.
                While we cannot ensure this profile will reciprocate, you are at
                least assured we will try. If so, you may then receive email
                notifications from this profile or other users who may help you
                meet more of such profiles.{" "}
                {/* <b
                  onClick={() =>
                    openUseGuide(USER_GUIDE_MODAL.COMPANY_SUGGESTED)
                  }
                  className="cursor-pointer"
                >
                  Learn more.
                </b> */}
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This is the nett amount which kimbocorp should receive for the
                quoted product or service. Please ensure to select “sender pay
                all fees” when executing your bank transfer.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This is the nett amount which kimbocorp should receive for the
                quoted product or service. Do ensure you account for any gas
                fees when executing your crypto transfer.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.STRIPE_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This is the quoted price of the product or service.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.STRIPE_TRANSACTION_FEES ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                We charge an additional 5% on top of the quoted price to cover
                for payment gateway transaction costs.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.STRIPE_STORAGE_FEES ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                We automatically store your product with Brinks Singapore who
                charges the quoted fees on a yearly basis. You will receive the
                proof of deposit and storage details after your product is
                deposited in the Brinks Vault in Singapore.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.STRIPE_SENDING_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                This is the nett amount which you are sending after all fees and
                charges.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.PAYMENT_PAID_UP_CAPITAL_LIMIT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                We can only accept paid-up capital equal to or more than $100 in
                USD or SGD. Top up the paid-up capital to a minimum of $100 in
                SGD or USD to pay for the paid-up capital.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType ===
          I_POP_OVER.SHAREHOLDERS_DIRECTOR_INVITEE_STATUS ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Invitation status will change when the invitee accepts the
                invite.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.WEALTH_RETENTION_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Wealth Retention</h5>
              <button type="button" className="btn-close close-button text-dark" onClick={infoModalStaticClose}></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The total value of assets this structure holds — investment portfolios, property, cash reserves, and other holdings.
              </p>
              <h6 className="edit-title mt-3">Why do we ask for this?</h6>
              <p className="edit-description">
                This figure — your <strong>Assets Under Management (AUM)</strong> — sets the rate for your Wealth Retention Platform Fee, calculated and collected <strong>every quarter</strong>, not once a year:
              </p>
              <ul className="edit-description m-0">
                <li>SGD 0 - 500k: 0.50% p.a.</li>
                <li>SGD 500k - 2M: 0.35% p.a.</li>
                <li>SGD 2M - 10M: 0.20% p.a.</li>
                <li>SGD 10M+: 0.10% p.a.</li>
              </ul>
              <p className="edit-description mt-3">
                <strong>Example:</strong> AUM of SGD 300,000 this quarter → 0.50% p.a., pro-rated for one quarter → roughly SGD 375.
              </p>
              <h6 className="edit-title mt-3">How it's paid</h6>
              <p className="edit-description">
                Payment is collected by direct debit authorisation (DDA). You will receive a statement after each draw showing the AUM figure used, the rate applied, and the resulting fee.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.TRADE_EFFICIENCY_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Trade Efficiency</h5>
              <button type="button" className="btn-close close-button text-dark" onClick={infoModalStaticClose}></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The total capital you expect to flow into this business this year, from any source — your own funds, customer payments, or trade proceeds — and by any method: card, telegraphic transfer (TT), cash, or other payment rails.
              </p>
              <h6 className="edit-title mt-3">Why do we ask for this?</h6>
              <p className="edit-description">
                This figure — your <strong>Expected Capital Inflow</strong> — sets your Trade Efficiency Platform Fee, calculated as a flat <strong>0.20% p.a.</strong>, and collected <strong>every quarter</strong>, not once a year. It includes all capital flowing into the business, however it arrives — your own funds, customer payments, card, TT, or crypto all count, not just trade transaction volume.
              </p>
              <p className="edit-description">
                <strong>Example:</strong> SGD 500,000 in capital inflow this quarter → 0.20% p.a., pro-rated for one quarter → roughly SGD 250.
              </p>
              <h6 className="edit-title mt-3">How it's paid</h6>
              <p className="edit-description">
                Payment is collected by direct debit authorisation (DDA). You will receive a statement after each draw showing the figure used, the rate applied, and the resulting fee.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.CAPITAL_ACCESS_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Capital Access</h5>
              <button type="button" className="btn-close close-button text-dark" onClick={infoModalStaticClose}></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The total capital you expect to bring into this business this year, from any source — your own funds, investor contributions, or other capital — and by any method: crypto, card, TT, or other payment rails.
              </p>
              <h6 className="edit-title mt-3">Why do we ask for this?</h6>
              <p className="edit-description">
                This figure — your <strong>Expected Capital Inflow</strong> — sets the rate for your Capital Access Platform Fee, calculated and collected <strong>every quarter</strong>, not once a year. It includes all capital regardless of source — your own funds, investor contributions, crypto, card, or TT all count:
              </p>
              <ul className="edit-description m-0">
                <li>SGD 0 - 500k: 0.50% p.a.</li>
                <li>SGD 500k - 2M: 0.35% p.a.</li>
                <li>SGD 2M - 10M: 0.20% p.a.</li>
                <li>SGD 10M+: 0.10% p.a.</li>
              </ul>
              <p className="edit-description mt-3">
                <strong>Example:</strong> SGD 300,000 in capital inflow this quarter → 0.50% p.a., pro-rated for one quarter → roughly SGD 375.
              </p>
              <h6 className="edit-title mt-3">How it's paid</h6>
              <p className="edit-description">
                Payment is collected by direct debit authorisation (DDA). You will receive a statement after each draw showing the figure used, the rate applied, and the resulting fee.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.DIGITAL_ASSETS_AMOUNT ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Digital Assets</h5>
              <button type="button" className="btn-close close-button text-dark" onClick={infoModalStaticClose}></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The total capital you expect to flow into this business this year, from any source — your own funds or customer funds — and by any method: crypto, card, TT, or other payment rails.
              </p>
              <h6 className="edit-title mt-3">Why do we ask for this?</h6>
              <p className="edit-description">
                This figure — your <strong>Expected Capital Inflow</strong> — sets your Digital Assets Platform Fee, calculated as a flat <strong>0.55% p.a.</strong>, and collected <strong>every quarter</strong>, not once a year. It includes all capital flowing into the business, however it arrives — your own funds, customer funds, crypto, card, or TT all count.
              </p>
              <p className="edit-description">
                <strong>Example:</strong> SGD 200,000 in capital inflow this quarter → 0.55% p.a., pro-rated for one quarter → roughly SGD 275.
              </p>
              <h6 className="edit-title mt-3">How it's paid</h6>
              <p className="edit-description">
                Payment is collected by direct debit authorisation (DDA). You will receive a statement after each draw showing the figure used, the rate applied, and the resulting fee.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.PLATFORM_FEE_REQUIRED ? (
          <>
            <div className="modal-header px-0 pt-0">
              <h5 className="edit-title">Why is there a Platform Fee?</h5>
              <button type="button" className="btn-close close-button text-dark" onClick={infoModalStaticClose}></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                The Activation Fee covers building your business. The Platform Fee covers keeping it running properly for as long as it is active.
              </p>
              <ul className="edit-description m-0">
                <li>Your resident director stays engaged.</li>
                <li>AI-led monitoring helps flag relevant regulatory requirements.</li>
                <li>You keep access to the platform, campaigns, quotations, tracking, and stakeholder management.</li>
                <li>Your banking relationship stays maintained and supported.</li>
              </ul>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.CUSTOM_API_MESSAGE ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">{infoModalStaticCustomMessage}</p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.COMPANY_PLAN ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                A <strong>company plan</strong> in kimbocorp is a <strong>subscription-based corporate
                  structure</strong> that allows you to <strong>incorporate and fully own a
                    Singapore Pte Ltd</strong>. Each plan defines how your business will
                operate, ensuring <strong>compliance, governance, and financial
                  efficiency</strong>. By subscribing to a company plan, you gain a <strong>wholly-owned Singapore-incorporated business</strong>, with structured
                support for compliance, business banking, and strategic
                growth—whether in <strong>trade, digital asset monetisation, or fund
                  management</strong>.
              </p>
            </div>
          </>
        ) : infoModalStaicShowType === I_POP_OVER.SERVICES_PLAN ? (
          <>
            <div className="modal-header px-0 pt-0">
              <button
                type="button"
                className="btn-close close-button text-dark"
                onClick={infoModalStaticClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="edit-description">
                Business services in kimbocorp are tailored solutions that
                support your Singapore-incorporated company’s operations. By
                subscribing to a service, your company gains direct access to
                growth, financial infrastructure, and regulatory advantages.
                From generating unlimited warm leads, opening multi-currency and
                crypto-to-fiat banking facilities, to securing tax residency in
                Singapore, kimbocorp ensures your business is structured for
                success.
              </p>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="modal-footer modal-bottom-action align-text-left">
          {infoModalStaicShowType === I_POP_OVER.BUSINESS_DETAIL ? (
            <SpeakToAdmin designType="popup" />
          ) : (
            infoModalStaicShowType ===
            I_POP_OVER.BOOK_OF_BUSINESS_SUGGESTED_POTENTIAL_PURPOSE && (
              <ContactUs
                type={CONTACT_US_TRIGER.BOB_POTENTIAL_PURPOSE}
                handleClose={handleClose}
              />
            )
          )}
          <button
            onClick={infoModalStaticClose}
            type="button"
            className="btn agree-button"
          >
            Got it
          </button>
        </div>
      </Modal>
    </>
  );
}
